import 'css-chunk:../../frontend/phi3d/src/js/components/IconExplanationFormSelect.module.scss';export default {
  "slot": "_slot_odidq_1",
  "icon": "_icon_odidq_7",
  "title": "_title_odidq_15"
};